import { login, sendSmsCode } from "@/api/common";
import { API_RESULT_CODE } from "@/config/types/common";
import { _cookie, _route } from "@/utils/constant";
import { Button, Form, Input, Toast } from "antd-mobile";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./index.less";
import queryString from "query-string";

const seconds = 60;
const Login = () => {
  const navigate = useNavigate();
  const [loginType, setLoginType] = useState("mobile");
  const [codeButton, setCodeButton] = useState("获取验证码");
  const [accountLogin] = Form.useForm();
  const [mobileLogin] = Form.useForm();
  const [submitLoading, setSubmitLoading] = useState(false);
  const [codeButtonDisabled, setCodeButtonDisabled] = useState(false);
  const [wait, setWait] = useState<number>(seconds);

  useEffect(() => {
    let timer: any = null;
    if (codeButtonDisabled && wait >= 0) {
      timer = setInterval(() => {
        setWait((n) => {
          if (n === 0) {
            setCodeButton("获取验证码");
            setCodeButtonDisabled(false);
            clearInterval(timer);
          } else {
            setCodeButton(`重新发送${n}s`);
          }
          return n - 1;
        });
      }, 1000);
    }
    return () => {
      // 组件销毁时，清除定时器
      clearInterval(timer);
    };
  }, [codeButtonDisabled, wait]);
  const switchLoginType = (type: "password" | "mobile") => {
    setLoginType(type);
  };
  const loginSuccess = (data: any) => {
    if (data.accessToken) {
      const date = new Date();
      date.setHours(date.getHours() + 24);
      Cookies.set(_cookie.TOKEN, data.accessToken, {
        path: "/",
        expires: date,
      });
      //登录时返回 当前账号是否为亲友号
      Cookies.set(_cookie.USER_INFO_FAMILY_ACCOUNT, data.isFamilyAccount, {
        path: "/",
        expires: date,
      });
      Toast.show("登录成功");
      const parsed = queryString.parse(window.location.search);
      const redirect = parsed.redirect ? String(parsed.redirect) : "";
      if (redirect) {
        window.location.href = redirect;
      } else {
        navigate(_route.SERVICE);
      }
    } else {
      Toast.show("下发的 accessToken 为空");
    }
  };
  const onAccountLogin = () => {
    accountLogin
      .validateFields()
      .then(async (values: any) => {
        try {
          setSubmitLoading(true);
          const { code, data, msg } = await login(values);
          setSubmitLoading(false);
          if (code === API_RESULT_CODE.SUCCESS) {
            Cookies.remove(_cookie.USER_INFO_FAMILY_ACCOUNT);
            loginSuccess(data);
          } else {
            Toast.show(msg);
          }
        } catch (err) {
          console.error(err);
        }
      })
      .catch((err: any) => {
        console.info();
        Toast.show({ content: err?.errorFields[0]?.errors[0] || "请补充信息" });
      });
  };
  const onMobileLogin = async () => {
    const values = await mobileLogin.validateFields();
    try {
      setSubmitLoading(true);
      const { code, data, msg } = await login({
        username: values.mobile,
        authMethod: "UsernameSM",
        checkCode: values.checkCode,
      });
      setSubmitLoading(false);
      if (code === API_RESULT_CODE.SUCCESS) {
        Cookies.remove(_cookie.USER_INFO_FAMILY_ACCOUNT);
        loginSuccess(data);
      } else {
        Toast.show(msg);
      }
    } catch (err) {
      console.error(err);
      setSubmitLoading(false);
    }
  };
  const getSmsCode = async () => {
    const data: any = {
      mobile: mobileLogin.getFieldValue("mobile"),
    };
    if (!data.mobile) {
      Toast.show({ content: "请输入手机号" });
      return;
    }
    const res: any = await sendSmsCode(data);
    if (res?.code === API_RESULT_CODE.SUCCESS) {
      Toast.show({ content: "验证码发送成功" });
      setCodeButtonDisabled(true);
      setWait(seconds);
    } else {
      Toast.show({ content: res?.message || res?.msg || "验证码发送失败" });
    }
    // const robotContainer = document.querySelector(".robot-captcha");
    // if (!robotContainer) {
    //   Toast.show({ content: "验证失败，请重试" });
    //   return;
    // }
    // setSubmitLoading(true);
    // robotCaptcha.show({
    //   ...AWSC,
    //   selector: robotContainer,
    //   onLoaded: () => {
    //     setSubmitLoading(false);
    //   },
    //   onSuccess: (values: any) => {
    //     sendCaptchaAfterRobot({ ...values, ...data });
    //   },
    //   onError: () => {
    //     Toast.show({ content: "验证失败，请重试" });
    //   },
    // });
  };

  return (
    <div className="login-page" style={{ padding: "100px 20px 0" }}>
      <div className="user-content">
        <Form
          style={{ display: loginType === "password" ? "block" : "none" }}
          form={accountLogin}
          className="login_form"
        >
          <Form.Item name="username" rules={[{ required: true, message: "请输入用户名" }]}>
            <Input className="input-part" type="tet" placeholder="请输入用户名" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: "请输入密码" }]}>
            <Input className="input-part" type="password" placeholder="请输入密码" />
          </Form.Item>
          <div className="forget-wrap">
            <div className="right" onClick={() => switchLoginType("mobile")}>
              使用短信验证码登录
            </div>
          </div>
          <Button block color="primary" loading={submitLoading} onClick={onAccountLogin}>
            登录
          </Button>
        </Form>
        <Form
          style={{ display: loginType === "mobile" ? "block" : "none" }}
          form={mobileLogin}
          className="login-form"
        >
          <Form.Item name="mobile" rules={[{ required: true, message: "请输入手机号" }]}>
            <Input className="input-part" type="text" placeholder="请输入手机号" />
          </Form.Item>
          <div className="form-get-code">
            <Form.Item name="checkCode" rules={[{ required: true, message: "请输入验证码" }]}>
              <Input className="input-part input-code" type="text" placeholder="验证码" />
            </Form.Item>
            <Button
              disabled={codeButtonDisabled}
              fill="none"
              className="send-button"
              onClick={getSmsCode}
            >
              {codeButton}
            </Button>
          </div>
          {/* <div className="robot-captcha"></div> */}
          <div className="forget-wrap">
            <div className="right" onClick={() => switchLoginType("password")}>
              使用账号密码登录
            </div>
          </div>
          <Button block color="primary" loading={submitLoading} onClick={onMobileLogin}>
            登录
          </Button>
        </Form>
      </div>
    </div>
  );
};
export default Login;
